"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./StarRating.css");
var icons = require("./../../../styles/att-icons.css");
var EventArgs_1 = require("../../../models/EventArgs");
var StarRating = /** @class */ (function (_super) {
    __extends(StarRating, _super);
    function StarRating(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { rate: props.data.rate || 1 };
        _this.onStarClick = _this.onStarClick.bind(_this);
        return _this;
    }
    StarRating.isPartialStar = function (value, rate) {
        return Math.ceil(rate) === value && rate % 1 !== 0;
    };
    StarRating.getDerivedStateFromProps = function (nextProps, prevState) {
        if (nextProps.data.rate === undefined || (nextProps.data.rate === prevState.rate)) {
            return null;
        }
        return {
            rate: nextProps.data.rate,
        };
    };
    StarRating.prototype.updateRate = function (rate) {
        if (rate != null && (rate !== this.state.rate)) {
            this.setState({ rate: rate });
        }
    };
    StarRating.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        if (this.state.rate === nextState.rate && this.props.data.readOnly === nextProps.data.readOnly) {
            return false;
        }
        return true;
    };
    StarRating.prototype.render = function () {
        return (React.createElement("div", { "data-test-id": this.props.testId, className: this.getContainerClasses() }, this.getGroup()));
    };
    StarRating.prototype.getContainerClasses = function () {
        var readOnly = this.props.data.readOnly;
        var containerClasses = [icons.attIcon, styles.startsContainer];
        if (readOnly) {
            containerClasses.push(styles.readOnly);
        }
        if (this.props.options && this.props.options.customClass) {
            containerClasses.push(this.props.options.customClass);
        }
        return containerClasses.join(' ');
    };
    StarRating.prototype.getGroup = function () {
        var starNodes = [];
        for (var i = 1; i <= this.props.data.starCount; i++) {
            var name_1 = this.props.data.name;
            var id = name_1 + "_" + i;
            starNodes.push(this.getRadioButton(i, name_1, id));
        }
        return starNodes;
    };
    StarRating.prototype.getRadioButton = function (value, name, id) {
        var readOnly = this.props.data.readOnly;
        return (React.createElement("label", { key: id, className: styles.starLabel },
            this.getStarIcon(value),
            React.createElement("span", { className: styles.screenreadertext }, "Star Ratings"),
            React.createElement("input", __assign({ className: styles.rateInput, type: "radio", name: name, value: value, checked: value === this.state.rate }, (readOnly ? {} : { onChange: this.onStarClick })))));
    };
    StarRating.prototype.getStarIcon = function (value) {
        return StarRating.isPartialStar(value, this.state.rate) ? this.getPartialStar() : this.getFullStar(value);
    };
    StarRating.prototype.getPartialStar = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("i", { className: [icons.attIconStarEmpty, styles.fixIconStyle].join(' ') }),
            React.createElement("i", __assign({}, this.getMaskStylesAttributes()))));
    };
    StarRating.prototype.getFullStar = function (value) {
        var iconClass = value <= this.state.rate ? icons.attIconStar : icons.attIconStarEmpty;
        return (React.createElement("i", { className: [iconClass, styles.fixIconStyle].join(' ') }));
    };
    StarRating.prototype.getMaskStylesAttributes = function () {
        var widthPercent = ((this.state.rate % 1) * 100);
        return {
            className: [styles.starMask, icons.attIconStar, styles.fixIconStyle].join(' '),
            style: { width: widthPercent.toFixed(2) + "%" },
        };
    };
    StarRating.prototype.onStarClick = function (e) {
        var rate = Number(e.currentTarget.value);
        this.setState({ rate: rate });
        this.props.events.onStarClick(new EventArgs_1.default(rate));
    };
    return StarRating;
}(React.Component));
exports.default = StarRating;
//# sourceMappingURL=StarRating.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/StarRating/StarRating.js
// module id = 1215
// module chunks = 8